export default "__VITE_PUBLIC_ASSET__86d823c3__"